import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { getCurrentUser } from 'aws-amplify/auth';
import { filter, firstValueFrom } from 'rxjs';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {
  constructor(private router: Router,
              private userService: UserService) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot, moduleName?: string): Promise<boolean | UrlTree> {
    console.debug('Loading component:', route, state, moduleName);

    // Check if the user is logged in
    try {
      await getCurrentUser();
    } catch {
      return this.router.parseUrl('/login');
    }

    // Wait for the real user: after login a null user is emitted first
    let user;
    try {
      user = await firstValueFrom(this.userService.$user.pipe(filter(u => !!u)));
    } catch {
      return this.router.parseUrl('/login');
    }
    const privs: any = user?.privileges ?? {};

    // Home page redirection based on group privileges
    // ('/' and '/home' mean "no redirect": redirecting to them would loop)
    if (state.url === '/home' && privs.homeURL && !['/', '/home'].includes(privs.homeURL)) {
      return this.router.parseUrl(privs.homeURL);
    }

    // Admins can access everything
    if (privs.isAdmin) {
      return true;
    }

    // Modules available to everybody don't pass a moduleName
    if (!moduleName) {
      return true;
    }

    // Check if the group permissions allow access to this component
    if (privs.modulesAvailable?.some((mod: { name: string }) => mod.name === moduleName)) {
      return true;
    }

    // Denied: go home, unless home itself was denied (redirecting would loop)
    // TODO: check the row level group permissions
    return state.url === '/home' ? false : this.router.parseUrl('/home');
  }
}
